import { OperatorPortalWorkPage } from "@/components/non_registrant/operator-portal-pages";
import { validateOperatorCasesSearch } from "@/lib/title-request-case-link";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/cases")({
  validateSearch: validateOperatorCasesSearch,
  component: OperatorPortalWorkPage,
});
